import React from 'react'
import { createComponent } from 'react-fela'
import Typography from 'design-framework/atoms/Typography'
import theme from 'design-framework/utils/base-ui-theme'
import { __badge } from './__style'

const colorsMap = {
	soldOut: 'white',
	fastFilling: 'white',
	available: 'bmsBlue',
	date: 'white',
	live: 'white',
	wip: theme.colors.pastelOrange,
	ready: theme.colors.readyGreen,
	onHold: 'white',
	chip: 'white',
}

const Badge = ({ children, variant, attribute = {}, mr, height }) => {
	const Wrapper = createComponent(__badge, 'div', Object.keys(attribute))

	return (
		<Wrapper variant={variant} mr={mr} height={height}>
			<Typography
				variant="overline"
				tag="label"
				attribute={attribute}
				color={colorsMap[variant]}
			>
				{children}
			</Typography>
		</Wrapper>
	)
}

Badge.defaultProptypes = {
	children: 'fast filling',
	variant: 'fastFilling',
	attribute: {},
}

export default Badge
